module.exports = __webpack_public_path__ + "static/media/5-item-a.cb4ef9b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/5-item-a.jpg
// module id = 1172
// module chunks = 33